export const userDataStorageName = 'MoovingUserData'